import React, { useState } from 'react';

import { injectIntl } from 'react-intl';

import { AppWrapper, Block, SendEmail } from 'components';
import AuthProtected from 'containers/AuthProtected/AuthProtected';
import Breadcrumbs from 'components/BreadCrumbs/BreadCrumbs';
import EmailTemplateManager from 'components/EmailTemplateManager/EmailTemplateManager';
import ToggleSearchBar from 'components/ToggleSearchBar/ToggleSearchBar';

const EmailManager = ({ intl }) => {
    const [mode, setMode] = useState('send-email');

    const handleModeChange = newMode => {
        setMode(newMode);
    };

    return (
        <AppWrapper
            showHeader
            showSideNav
            showHeadingRow
            headingText="Email Manager"
        >
            <AuthProtected />

            <div className="col-md-12">
                <Breadcrumbs locationArray={['Admin', 'Email Manager']} />

                <ToggleSearchBar
                    options={[
                        {
                            label: 'Send Emails',
                            value: 'send-email',
                        },
                        {
                            label: 'Manage Templates',
                            value: 'manage',
                        },
                    ]}
                    activeValue={mode}
                    onChange={handleModeChange}
                />

                <Block>
                    {mode === 'send-email' && (
                        <SendEmail />
                    )}

                    {mode === 'manage' && (
                        <EmailTemplateManager />
                    )}
                </Block>
            </div>
        </AppWrapper>
    );
};

export default injectIntl(EmailManager);